import React from "react";
import { Link } from "@quintype/components";
import { object, string } from "prop-types";
import get from "lodash/get";

import "./subSectionsMenuItems.m.css";

const SubSectionsMenuItems = ({ sectionsDataForHeader = null, src, language = "bn" }) => {
  const childSections = get(sectionsDataForHeader, ["childSections"], []);

  if (!childSections.length) {
    return null;
  }

  const headerWrapperStyleName = src !== "section" ? "header-sections" : "";
  const headerChildSectionStyleName = headerWrapperStyleName && language === "en" ? "en-child-section" : "";
  const englishSiteSectionPageWrapperStyleName = language === "en" ? "en-sub-sections" : "";

  return (
    <ul
      styleName={`sub-sections ${headerWrapperStyleName} ${englishSiteSectionPageWrapperStyleName}`}
      className="sub-sections"
    >
      {childSections.slice(0, 12).map((item, index) => {
        const currentSectionClassName =
          sectionsDataForHeader.currentSection === item["display-name"] ? "current-section" : "";

        return (
          <li
            styleName={`child-section ${language}-section ${headerChildSectionStyleName}`}
            className={`child-section ${currentSectionClassName}`}
            key={index}
          >
            <Link href={item["section-url"]}>{item["display-name"]}</Link>
          </li>
        );
      })}
    </ul>
  );
};

SubSectionsMenuItems.propTypes = {
  sectionsDataForHeader: object,
  src: string,
  language: string,
};

export default SubSectionsMenuItems;
